import { formatNumberForEdit, parseEditedNumber, isValidCharacter } from './numberUtils';

const numeral = require('numeral');

class CustomNumberCellEditor {
  init(params) {
    this.params = params;
    this.multiplier = params.multiplier || 1;

    const currentLocale = numeral.options.currentLocale;

    this.decimalSeparator =
      params.decimalSeparator || numeral.locales[currentLocale].delimiters.decimal;

    this.eInput = document.createElement('input');
    this.eInput.type = 'text';
    this.eInput.className = 'ag-input';
    this.eInput.style.width = '100%';

    this.eInput.value = formatNumberForEdit({
      value: params.value,
      multiplier: this.multiplier,
      decimalSeparator: this.decimalSeparator,
      valuePrecision: params.valuePrecision,
    });

    // Excel-like: typing to start editing replaces the existing value
    const { eventKey } = params;
    const startedWithValidChar =
      eventKey?.length === 1 &&
      isValidCharacter({
        key: eventKey,
        currentValue: '',
        selectionStart: 0,
        decimalSeparator: this.decimalSeparator,
      });
    if (startedWithValidChar) {
      this.eInput.value = eventKey;
    } else if (eventKey === 'Backspace' || eventKey === 'Delete') {
      this.eInput.value = '';
    } else if (eventKey?.length === 1) {
      // If the input isn't valid (i.e. its a letter) - do nothing and dont' select
      this.cancelBeforeStart = true;
    }

    this.eInput.addEventListener('keypress', this.restrictInput.bind(this));
  }

  getGui() {
    return this.eInput;
  }

  // Ag-grid calls this to prevent input
  isCancelBeforeStart() {
    return !!this.cancelBeforeStart;
  }

  afterGuiAttached() {
    this.eInput.focus();
    const end = this.eInput.value.length;
    this.eInput.setSelectionRange(end, end);
  }

  getValue() {
    return parseEditedNumber({
      value: this.eInput.value,
      multiplier: this.multiplier,
      decimalSeparator: this.decimalSeparator,
      emptyValue: this.params.emptyValue ?? null,
      valuePrecision: this.params.valuePrecision,
    });
  }

  restrictInput(event) {
    const valid = isValidCharacter({
      key: event.key,
      currentValue: this.eInput.value,
      selectionStart: this.eInput.selectionStart,
      decimalSeparator: this.decimalSeparator,
    });

    if (!valid) {
      event.preventDefault();
    }
  }
}

export default CustomNumberCellEditor;
